import { Injectable } from "@angular/core";
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, ActivatedRoute } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { AppConstants } from "../app.constants";
import { HttpModel } from "../models/http.model";
import { AuthenticatedHttp } from "../services/http.service";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService, private authHttp: AuthenticatedHttp, private routing: ActivatedRoute) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (state.url.startsWith("/registration")) {
      if (this.authService.$loggedIn.getValue()) {
        this.authService.setAuth(null);
        this.router.navigate(["login"]);
      }
      return true;
    } else if (this.authService.$loggedIn.getValue() && !this.authService.isTokenExpired()) {
      // logged in so return true
      return true;
    } else if (route.queryParams["jwtToken"]) {
      return true;
    } else if (route.queryParams["mailValidated"]) {
      if (this.authService.$loggedIn.getValue()) {
        return true;
      } else {
        if (state.url === "/login?mailValidated=true") {
          return true;
        } else {
          const queryParams = {};
          queryParams["mailValidated"] = "true";
          this.router.navigate(["/login"],  { queryParams, relativeTo: this.routing,  queryParamsHandling: "merge"});
          return false;
        }
      }
    } else if (!state.url.startsWith("/login")) {
      // not logged in so redirect to login page
      this.router.navigate(["/login"], { queryParams: { unhandled: "true" }, queryParamsHandling: "preserve"});
      return false;
    }
    else {
      return true;
    }
  }
}
